import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/cart-with-box-outline-blue.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 flex items-center gap-4 justify-between border-bottom-grey-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "icon"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Harga BBM")
  ])
], -1)
const _hoisted_2 = { class: "pt-4" }
const _hoisted_3 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Harga BBM"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Rincian jenis BBM dan harga yang dijual oleh pom bensin partner")
], -1)
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "text-base font-bold" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = { class: "p-inputgroup flex-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "/ Liter", -1)
const _hoisted_11 = { class: "p-error" }
const _hoisted_12 = { class: "flex items-center justify-end mt-6" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Simpan")

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiUseCase from '@/usecase/apiUseCase'
import Card from 'primevue/card'
import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Field, useForm } from 'vee-validate'
import * as Yup from 'yup'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'FuelPriceForm',
  setup(__props) {

const fuelTransactionVoucherEndpoint = '/transaction/v2/FuelTransactionVouchers'
const fuelStationPartnerEndpoint = '/management/v2/FuelStationPartners'
const backRouteName = 'master-spbu'
const store = useStore()
const route = useRoute()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataHeader = ref(null) as any
const dataSource = ref([]) as any
const schema = Yup.object({
  items: Yup.array().of(
    Yup.object({
      Name: Yup.string().required(),
      Price: Yup.number()
        .typeError('Harga harus berupa angka')
        .required('Harga wajib diisi')
        .min(1, 'Harga minimal 1')
        .max(999999, 'Harga maksimal 6 digit')
    })
  )
})

const { values, errors, setFieldValue, handleSubmit, resetForm } = useForm({
  validationSchema: schema,
  initialValues: {
    items: []
  }
})

const getFuelTypes = () => {
  store.dispatch('showLoading')
  apiUseCase.get(`${fuelTransactionVoucherEndpoint}/FuelTypes`).then((response) => {
    const { error, result } = response
    console.log('res', result)
    dataSource.value = result.map((itemB: any) => {
      const found = dataHeader.value.Stocks.find((itemA: any) => itemA.Name === itemB.Name)

      return {
        Name: itemB.Name,
        CurrentStock: found.CurrentStock ?? 0,
        Price: found.Price ?? 0
      }
    })
    resetForm({
      values: {
        items: dataSource.value
      }
    })
    // console.log('x', temp)
  })
  store.dispatch('hideLoading')
}

const processSubmit = async (payload: any) => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.put(`${fuelStationPartnerEndpoint}/${dataHeader.value?.Id}/Stocks`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: 'Harga BBM berhasil diubah',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        toPrevPage()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal mengubah harga BBM',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal mengubah harga BBM',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmit = handleSubmit((dataValue: any) => {
  // console.log('data', dataValue)
  const payload = dataValue.items
  processSubmit(payload)
})

const toPrevPage = () => {
  router.push({
    name: 'master-spbu'
  })
}

onMounted(() => {
  dataHeader.value = encryptDecriptMethods.decrypt(route.params.id)
  console.log('dataHeader', dataHeader)
  getFuelTypes()
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Partner SPBU',
      routeName: backRouteName
    },
    {
      title: `Edit Harga BBM - ${dataHeader.value?.Name}`,
      routeName: `${backRouteName}-fuel-form`,
      params: { id: route.params.id }
    }
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
    }, [
      _createVNode(_unref(Card), { lass: "card-no-shadow" }, {
        content: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(values).items, (data, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data.Name,
                    class: "md:grid grid-cols-3 gap-2 mb-3 items-center"
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(data.Name), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(Field), {
                        name: `items.${index}.Price`
                      }, {
                        default: _withCtx(({ field }) => [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createVNode(_unref(InputNumber), {
                              modelValue: field.value,
                              "onUpdate:modelValue": value => _unref(setFieldValue)(`items[${index}].Price`, value),
                              onBlur: field.handleBlur,
                              min: 0,
                              placeholder: "Masukkan harga",
                              class: "w-full",
                              inputClass: [
                          'w-full',
                          { 'p-invalid': !!_unref(errors)[`items[${index}].Price`] }
                        ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "inputClass"]),
                            _hoisted_10
                          ]),
                          _createElementVNode("small", _hoisted_11, _toDisplayString(_unref(errors)[`items[${index}].Price`]), 1)
                        ]),
                        _: 2
                      }, 1032, ["name"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toPrevPage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                id: "Submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ], 32)
  ]))
}
}

})